exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls_controls-container_2xinB {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.controls_keyborad_2PbxI{\n    width: 32px;\n    height: 32px;\n    padding: 4px;\n}\n\n.controls_keyborad_2PbxI img{\n    width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"controls-container": "controls_controls-container_2xinB",
	"controlsContainer": "controls_controls-container_2xinB",
	"keyborad": "controls_keyborad_2PbxI"
};